import { render, staticRenderFns } from "./carInfo.vue?vue&type=template&id=3557e549&scoped=true&"
import script from "./carInfo.vue?vue&type=script&lang=js&"
export * from "./carInfo.vue?vue&type=script&lang=js&"
import style0 from "./carInfo.vue?vue&type=style&index=0&id=3557e549&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3557e549",
  null
  
)

export default component.exports